import { useGetMeQuery } from '@api/apiCompat';
import { USER_ACCESS_TOKEN } from '@constants/auth';

export const useUser = () => {
  // Skip the /me query entirely when there's no token — the public Pricing
  // page renders for logged-out visitors and shouldn't fire a guaranteed 401.
  const hasToken = typeof window !== 'undefined' && !!localStorage.getItem(USER_ACCESS_TOKEN);
  const { data, isLoading, error, refetch } = useGetMeQuery(undefined, {
    refetchOnFocus: true,
    skip: !hasToken,
  });

  return { data, isLoading, error, refetch };
};
